import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AvailabilityRate, NormalizedCart } from '@/lib/booking-engine/types'

export type CartItem = {
  roomTypeId: string
  rateId: string
  quantity: number
  rate: AvailabilityRate
}

export type Stay = {
  checkIn: string
  checkOut: string
  guests?: number | null
  nights?: number | null
  hotelSlug: string
}

type CartStore = {
  sessionId: string | null
  stay: Stay

  cart: NormalizedCart | null
  isLoading: boolean

  setSessionId: (sessionId: string) => void
  setStay: (stay: Stay) => void
  setCart: (cart: NormalizedCart) => void
  setLoading: (loading: boolean) => void

  clearCart: () => void
  resetCart: () => void
}

export const useCartStore = create<CartStore>()(
  persist(
    (set) => ({
      sessionId: null,
      stay: {
        checkIn: '',
        checkOut: '',
        guests: null,
        nights: null,
        hotelSlug: '',
      },
      cart: null,
      isLoading: false,

      setSessionId: (sessionId) => {
        document.cookie = `sessionId=${sessionId}; path=/; Secure; SameSite=Lax; max-age=86400`
        set({ sessionId })
      },

      setStay: (stay) => {
        document.cookie = `hotel=${stay.hotelSlug}; path=/; Secure; SameSite=Strict; max-age=86400`
        set({ stay })
      },

      setCart: (cart) => set({ cart }),

      setLoading: (isLoading) => set({ isLoading }),

      clearCart: () => {
        document.cookie = 'hotel=; path=/; max-age=0'
        document.cookie = 'sessionId=; path=/; max-age=0'
        set({
          sessionId: null,
          cart: null,
          stay: { checkIn: '', checkOut: '', guests: null, nights: null, hotelSlug: '' },
        })
      },

      resetCart: () => {
        document.cookie = 'hotel=; path=/; max-age=0'
        document.cookie = 'sessionId=; path=/; max-age=0'
        set({
          sessionId: null,
          cart: null,
          stay: { checkIn: '', checkOut: '', guests: null, nights: null, hotelSlug: '' },
        })
      },
    }),
    {
      name: 'cart',
      partialize: (state) => ({
        sessionId: state.sessionId,
        stay: state.stay,
        cart: state.cart,
      }),
    },
  ),
)
